export const formatMoney = (amount: number, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 2,
    // eslint-disable-next-line no-compare-neg-zero
  }).format(amount === -0 ? 0 : amount);
};
